"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaginationProgress = void 0;
const getPaginationProgress = (countOfLoadedArticles, countOfArticles) => countOfArticles === undefined || countOfArticles < 1 ? 0 : countOfLoadedArticles / countOfArticles * 100;
exports.getPaginationProgress = getPaginationProgress;
